// extracted by mini-css-extract-plugin
module.exports = {"inputCheckbox":"styles_inputCheckbox__hh9lK","inputCheckboxIcon":"styles_inputCheckboxIcon__tP_Vm"};